module.exports = __webpack_public_path__ + "img/C.93e08fc5.png";